import React, { useState, useEffect } from "react";
import Img from "../image/Image";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

// import { boolean } from "yargs";

const checkImageURL = (url: string) => {
  return new Promise((resolve) => {
    const img = new Image();

    img.onload = () => {
      resolve(true);
    };

    img.onerror = () => {
      resolve(false);
    };

    img.src = url;
  });
};

interface myMycomponentProps {
  url?: string;
  children?: React.ReactNode;
  className?: string;
}

const RazorImage = ({ url, children, className }: myMycomponentProps) => {
  const [imageValid, setImageValid] = useState(null);

  useEffect(() => {
    const imageUrl = url;

    checkImageURL(imageUrl as any).then((isValid) => {
      setImageValid(isValid as any);
    });
  }, [url]);

  if (imageValid === null) {
    return " ";
  }

  return (
    <div>
      {imageValid ? (
        <figure className={`img-box ${className && className}`}>
          {" "}
          <Img src={String(url)} alt="" className="img" />
        </figure>
      ) : (
        <>{children}</>
      )}
    </div>
  );
};

// Component props interface
interface MyComponentProps {
  url?: string;
  children?: React.ReactNode;
  className?: string;
  styles?: any;
  loadSize?: any;
  circleSkeleton?: any;
}

// ImageFragment component
const RazorImageFallback = ({
  url,
  children,
  className,
  styles,
  loadSize,
  circleSkeleton,
}: MyComponentProps) => {
  const [imageValid, setImageValid] = useState<boolean | null>(null);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const imageUrl = url;

    if (imageUrl) {
      checkImageURL(imageUrl).then((isValid) => {
        setImageValid(isValid as boolean);
        setLoading(false);
      });
    } else {
      setLoading(false);
    }
  }, [url]);

  if (loading) {
    return (
      <div style={{ overflow: "hidden" }} className="img-box">
        <Skeleton
          width={loadSize || 35}
          height={loadSize || 35}
          circle={circleSkeleton || true}
        />
      </div>
    ); // You can customize the loading indicator as needed
  }

  return (
    <div>
      {imageValid ? (
        <figure style={styles} className={`img-box ${className && className}`}>
          <img src={url} alt="" className="img" />
        </figure>
      ) : (
        <>{children}</>
      )}
    </div>
  );
};

export { RazorImageFallback, RazorImage };
